import { createFileRoute } from '@tanstack/react-router';
import { z } from 'zod';

import { ResetPasswordPage } from '~/features/auth/pages/reset-password-page';

const searchSchema = z.object({
  user_id: z.string().optional(),
  token: z.string().optional(),
});

export const Route = createFileRoute('/reset-password')({
  validateSearch: searchSchema,
  component: ResetPasswordPage,
});
